import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClimateMonitoringComponent } from './climateMonitoring.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [ClimateMonitoringComponent]
})
export class ClimateMonitoringModule { }
